import {
  ACCEPT_REJECT,
  ACCEPT_REJECT_SUCCESS,
  ACCEPT_REJECT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  kycData: {},
};

const kycAuthReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACCEPT_REJECT:
      return { ...state, loading: true };
    case ACCEPT_REJECT_SUCCESS:
      return {
        ...state,
        kycData: action?.payload,
        loading: false,
      };
    case ACCEPT_REJECT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default kycAuthReducer;
